import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { getThuistaxatieRequests } from 'redux/actions/data'
import ThuistaxatieView from 'components/views/thuistaxatie'

const mapStateToProps = ({ data }) => ({
  thuistaxatieRequests: data.thuistaxatieRequests,
})

const mapDispatchToProps = {
  getThuistaxatieRequests,
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ThuistaxatieView),
)
